export const illustrationImage = {
  medium: 'https://assets.riparide.com/home/intro/map@1x_03-11-2021.jpg',
  large: 'https://assets.riparide.com/home/intro/map@2x_03-11-2021.jpg',
}
